export default {
  colors: {
    primary: '#3B24A8',
  },
  breakpoints: ['544px', '768px', '1012px', '1280px'],
  borderRadius: '8px',
};
